<template>
  <div class="my-10">
    <svg style="margin-bottom: -7px; margin-left: calc((100% - 100vw)/2); width: 100vw;" viewBox="0 0 2089 111" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M365.5 30.5C230.5 30.5 138 38 0.552948 101.987C0.510406 104.76 0.469421 107.598 0.429962 110.499H2088.55L2077.5 17C1891.5 101.987 1588.4 0 1418 0C1224.5 0 928 64.5 778 64.5C658 64.5 408 30.5 365.5 30.5Z" fill="#fef2df"/>
    </svg>
    <!-- <img class="w-screen" style="margin-bottom: -5px;" alt="Borda superior do conteúdo" src="../../assets/layout/section_top.png"> -->
    <div class="content-section fit-width">
      <div class="main-content inline-block">
        <h2 class="inline-block w-5/6" style="margin-top: -170px;">{{ title }}</h2>
        <slot></slot>
      </div>
    </div>
    <svg style="margin-top: -1px; margin-left: calc((100% - 100vw)/2); width: 100vw;" viewBox="0 0 2089 78" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0C0.148816 32.2897 0.259286 59.4011 0.259286 77.9127L3.45237 76.9176L3.45508 76.9168C139.627 34.4832 227.658 7.05093 413.759 7.05093C489.203 7.05093 593.01 1.82265 711.206 20C823.23 37.2281 945.476 54.5 1009.71 54.5C1083.35 54.5 1204.87 55.823 1308.24 36.3101C1390.15 20.8482 1463.49 7.00423 1499.88 7.05093C1706.76 7.05093 1939.26 7.05093 2088.26 54.131V0H0Z" fill="#fef2df"/>
    </svg>
    <!-- <img class="w-screen" style="margin-top: -1px;" alt="Borda inferior do conteúdo" src="../../assets/layout/section_bottom.png"> -->
  </div>
</template>

<script>
export default {
    props: ['title']
}
</script>

<style scoped>
.content-section {
  background-color: #fef2df;
}
</style>